import {
    DTOCardFormField, NestedField,
} from 'app/types/form.types'

import {
    BillingCompany,
} from '../../BillingCompanyForm.types'

const getAbacusSettingsFields = (
    {
        isNew,
        disabled,
        isSyncedWithAbacusDisabled = false,
    }: {
        isNew: boolean,
        disabled?: boolean,
        isSyncedWithAbacusDisabled?: boolean,
    },
): DTOCardFormField<keyof BillingCompany> => {
    return {
        id: 'abacusSettings',
        title: 'Abacus Settings',
        className: 'abacusSettings',
        'data-testid': 'card-abacusSettings',
        fields: [
            {
                id: 'abacusSettings-column1',
                fields: [
                    {
                        name: 'hasBulkInvoice',
                        componentName: 'Switch',
                        labelKey: 'BillingCompanyDto.hasBulkInvoice',
                    },
                    {
                        name: 'isMainAddress',
                        componentName: 'Switch',
                        labelKey: 'BillingCompanyDto.isMainAddress',
                    },
                    {
                        name: 'markUp',
                        componentName: 'InputSingleline',
                        labelKey: 'BillingCompanyDto.markUp',
                    },
                    ...!isNew ? [{
                        name: 'isSyncedWithAbacus',
                        componentName: 'Checkbox',
                        labelKey: 'BillingCompanyDto.isSyncedWithAbacus',
                        disabled: isSyncedWithAbacusDisabled || disabled,
                    }] as NestedField<keyof BillingCompany>[] : [],
                    {
                        name: 'abacusKeyCustomerNumber',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'BillingCompanyDto.abacusKeyCustomerNumber',
                    },
                    {
                        name: 'abacusKeyAddressNumber',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'BillingCompanyDto.abacusKeyAddressNumber',
                    },
                ],
            },
            {
                id: 'abacusSettings-column2',
                fields: [{
                    name: 'defaultTaxCode',
                    componentName: 'TaxCodesSelector',
                    labelKey: 'BillingCompanyDto.defaultTaxCode',
                    isNew,
                }],
            },
        ],
    }
}

export default getAbacusSettingsFields
